import Moment from 'moment'
// function toString (obj) {
//   return Object.prototype.toString.call(obj);
// }

// function isType (type) {
//   return function (target) {
//     return toString(target) === `[object ${type}]`
//   }
// }
// const isString = isType('String');
// const isWx = function () {
//   const ua = window.navigator.userAgent.toLowerCase();
//   if (ua.indexOf('micromessenger') < 0) {
//     return false;
//   }
//   return true;
// }
import { findAll } from '@/assets/js/api.js'
export const Utils = {
	hasOver: async function(to) {
		let city = (to.query.discern && to.query.discern.split('_')[1]) || Utils.parseQuery().city || 'shanghai'
		const data = await findAll({ city: city })
		if (data.code === '00000') {
			console.log(city)
			if (data.data[0] && data.data[0].city == city) {
				var timeArr = data.data
				var oid2 = timeArr[timeArr.length - 1].date
				var oid2Time = parseInt(oid2.substr(6, 2)) + 2
				var oids = oid2.substr(0, 2) + oid2.substr(2, 2) + oid2Time
				let year =
					parseInt(oid2.substr(0, 2)) == 1
						? parseInt(Moment().format('YYYY')) + 1
						: parseInt(Moment().format('YYYY'))
				oids = parseInt(year + '' + oids)
				console.log(oids)
				console.log(Utils.getCurrentDateStr())
				//判断活动是否结束
				if (parseInt(oids) < Utils.getCurrentDateStr()) {
					return true
				}
			}
			return false
		} else {
			alert('预约时间获取失败')
		}
	},
	scrollResolve: function() {
		const arr = navigator.userAgent.toLowerCase().match(/cpu iphone os (.*?) like mac os/)
		var iosV = 0
		if (arr && arr.length) {
			iosV = parseInt(arr[1].replace(/_/g, '.'))
		}
		if (iosV < 12) return
		let currentPosition
		let speed = 1
		setTimeout(function() {
			currentPosition = document.documentElement.scrollTop || document.body.scrollTop
			currentPosition -= speed
			window.scrollTo(0, currentPosition) //页面向上滚动
			currentPosition += speed
			window.scrollTo(0, currentPosition) //页面向下滚动
		}, 100)
	},
	deleteObjEmpty: function(search = {}) {
		for (let i in search) {
			(search[i] === '' || search[i] === undefined || search[i] === null) && delete search[i]
		}
		return search
	},
	parseQuery: function(r, t) {
		let n,
			i = {}
		return (
			(r = r || location.search.substr(1)),
			(t = t || '&'),
			(n = r.split(t)),
			n.forEach(function(r) {
				if ('' !== r) {
					let n = r.split('=')
					i[n[0]] = n[1]
				}
			}),
			i
		)
	},
	isPC: function() {
		var userAgentInfo = navigator.userAgent
		var Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
		var flag = true
		for (var v = 0; v < Agents.length; v++) {
			if (userAgentInfo.indexOf(Agents[v]) > 0) {
				flag = false
				break
			}
		}
		return flag
	},
	isIos: function() {
		let u = navigator.userAgent
		let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
		return isIOS
	},
	getCurrentDateStr: function() {
		return parseInt(Moment().format('YYYYMMDDHH'))
	},
	getLocal: function() {
		const data = JSON.parse(localStorage.getItem('n5-holiday-podium'))
		return data
	},
	setLocal: function(data) {
		localStorage.setItem('n5-holiday-podium', data)
	},
	isNull: function(value) {
		//只输入空字符时校验
		if (value.replace(/(^\s*)|(\s*$)/g, '') === '' && /\s/.test(value)) return true
		return false
	},
	focus() {
		this.placeholder = ''
		if (/Android [4-9]/.test(navigator.appVersion)) {
			window.addEventListener('resize', function() {
				if (document.activeElement.tagName == 'INPUT' || document.activeElement.tagName == 'TEXTAREA') {
					window.setTimeout(function() {
						document.activeElement.scrollIntoViewIfNeeded()
					}, 0)
				}
			})
		}
	},
	scrollFix: function(elem) {
		let startTopScroll
		elem = elem || document.querySelector(elem)

		if (!elem) return
		elem.addEventListener(
			'touchstart',
			function() {
				startTopScroll = elem.scrollTop
				if (startTopScroll <= 0) elem.scrollTop = 1

				if (startTopScroll + elem.offsetHeight >= elem.scrollHeight)
					elem.scrollTop = elem.scrollHeight - elem.offsetHeight - 1
			},
			false
		)
	},
	cursorSlide() {
		document.body.addEventListener(
			'touchmove',
			function() {
				if (document.activeElement) document.activeElement.blur()
			},
			{ passive: false }
		)
	},
	cursorFix(elem) {
		elem.onscroll = function() {
			var node = document.activeElement //当前focus的dom元素
			if (node) {
				if (node.nodeName == 'TEXTAREA' || node.nodeName == 'INPUT') {
					//如果是input或textarea
					if (node.style.textShadow === '') {
						node.style.textShadow = 'rgba(0,0,0,0) 0 0 0' //改变某个不可见样式，触发dom重绘
					} else {
						node.style.textShadow = ''
					}
				}
			}
		}
	},
	getCurrentDateStr1: function() {
		var month = new Date().getMonth() + 1
		var date = new Date().getDate()
		var hour = new Date().getHours()
		var minute = new Date().getMinutes()
		if (month < 10) month = '0' + month
		if (date < 10) date = '0' + date
		if (hour < 10) hour = '0' + hour
		if (minute < 10) minute = '0' + minute
		return parseInt('' + month + date + hour)
	},
	getWeekName(val) {
		switch (val) {
			case 0:
				return '日'
			case 1:
				return '一'
			case 2:
				return '二'
			case 3:
				return '三'
			case 4:
				return '四'
			case 5:
				return '五'
			case 6:
				return '六'
			default:
				break
		}
	},
	/**
	 * input 光标定位最后
	 * @param {*} input
	 * @param {*} selectionStart
	 * @param {*} selectionEnd
	 */
	setSelectionRange(input, selectionStart, selectionEnd) {
		if (input.setSelectionRange) {
			input.focus()
			input.setSelectionRange(selectionStart, selectionEnd)
		} else if (input.createTextRange) {
			var range = input.createTextRange()
			range.collapse(true)
			range.moveEnd('character', selectionEnd)
			range.moveStart('character', selectionStart)
			range.select()
		}
	},
}
